/**
 * Eixo 2B da discovery 2026-09-11 — pré-validação de imagem no envio.
 *
 * Sem OCR de conteúdo: métricas baratas por página (nitidez, página em branco, contagem de
 * páginas contra a declarada). Só avisa, **nunca bloqueia** — limiar de scanner não é igual ao
 * de celular, e um envio barrado por um falso positivo custa mais que um aviso ignorado.
 *
 * Os códigos vêm do backend em `qualityWarnings`, com a página no sufixo (`PAGE_BLURRY:2`).
 */

export const QUALITY_WARNING_TEMPLATES: Record<string, (page: string) => string> = {
  PAGE_BLURRY: (page) => `Página ${page} está desfocada`,
  PAGE_BLANK: (page) => `Página ${page} parece em branco`
}

export const QUALITY_WARNING_LABELS: Record<string, string> = {
  PAGE_COUNT_MISMATCH: 'Quantidade de páginas diferente da declarada'
}

/**
 * Código desconhecido volta cru em vez de desaparecer: o backend pode ganhar uma métrica nova
 * antes do deploy do web, e esconder o aviso é o único desfecho pior que mostrá-lo em inglês.
 */
export function translateQualityWarning(code: string): string {
  const [prefix, page] = code.split(':')

  if (page && QUALITY_WARNING_TEMPLATES[prefix]) {
    return QUALITY_WARNING_TEMPLATES[prefix](page)
  }

  return QUALITY_WARNING_LABELS[prefix] ?? code
}

export function translateQualityWarnings(codes: string[] | null | undefined): string[] {
  return (codes ?? []).filter(Boolean).map(translateQualityWarning)
}

/** Título do painel: "2 avisos nesta folha", como o mockup. */
export function qualityWarningsTitle(count: number): string {
  return count === 1 ? '1 aviso nesta folha' : `${count} avisos nesta folha`
}
